require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-biggest-day-to-day-changes-from-obj-c-to-swift-part-1.json") })
        }
      }, "path---blog-biggest-day-to-day-changes-from-obj-c-to-swift-part-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-biggest-day-to-day-changes-from-obj-c-to-swift-part-1!./.cache/json/blog-biggest-day-to-day-changes-from-obj-c-to-swift-part-1.json
// module id = 728
// module chunks = 231608221292675